module.exports = __webpack_public_path__ + "img/products_big_can_green.7d04e4db.png";